import { StaticProvider } from '@angular/core';
import {
  RxapFormControl,
  RxapFormGroup,
} from 'eurogard-forms';
import { TableSelectColumnMap } from './open-table-select-window.method';
import { EUROGARD_TABLE_FILTER_FORM_DEFINITION } from 'angular-components/table-system';

export function CreateFilterFormProvider(columns: TableSelectColumnMap): StaticProvider {

  const columnNameList: string[] = Array.from(columns.entries())
                                        .filter(([ key, column ]) => column.filter)
                                        .map(([ key, column ]) => key);

  const controls: Record<string, RxapFormControl> = {};

  for (const column of columnNameList) {
    controls[column] = new RxapFormControl(null, { controlId: column });
    // set the filtered enum values as default (if undefined the filter will be empty)
    controls[column].patchValue(columns.get(column)?.filteredEnumValues);
  }

  const form = {
    ...controls,
    rxapFormGroup: new RxapFormGroup(controls, { controlId: 'filter' }),
    rxapMetadata: { controlId: 'filter' },
  };

  Reflect.set(form.rxapFormGroup, '_rxapFormDefinition', form);

  return {
    provide: EUROGARD_TABLE_FILTER_FORM_DEFINITION,
    useValue: form,
  };

}
